module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/342.881e4f1b.png";